$( document ).ready(function() {
    slideReview();
    faqAccordion();
  
    function slideReview() {
      let rev = $('.home-review__wrapper');

      rev.flipster({
        loop: 2,
        start: 2,
        spacing: 0,
        nav: true,
        buttons: true,
        scrollwheel: false,
        autoplay: 5000,
        style: 'infinite-carousel',
      });
    }

    function faqAccordion() {
      $(".faq-item-title").click(function () {
        if ($(this).hasClass('is-active')){
            $(this).next(".faq-item-content").slideUp('slow');
            $(this).removeClass('is-active');
        }
        else {
          // close other content
          $(".faq-item-title").not(this).next(".faq-item-content").slideUp('slow');
          $(".faq-item-title").not(this).removeClass('is-active');
          $(this).next(".faq-item-content").slideDown('slow');
          $(this).addClass('is-active');
        }
      });
    }
});